// List of all flags
export const Feature = {
    IsIdpIELTS: 'Is-Idp-IELTS',
};
